import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterMatchMode, LazyLoadEvent, MessageService, SelectItem } from 'primeng/api';
import { AuthGuard } from 'src/app/account/auth/app.gaurd';
import { helperService } from 'src/app/utils/helper';
import { MatterService } from './matter.service';
import { matchModeOptionsDateList, matter } from 'src/app/utils/filterDropDownData';
import { SavedTableState, TableStateService } from 'src/app/shared/table-state.service';

@Component({
    selector: 'app-matters',
    templateUrl: './matters.component.html',
    styleUrls: ['./matters.component.scss'],
    standalone: false
})
export class MattersComponent implements OnInit {

  @Input()
  matterOrgFilter: any = null;
  matterData: any;
  cols: any[] = [];
  statuses: any = [];
  matchModeOptionsString?: SelectItem[];
  matchModeOptions?: SelectItem[];
  matchModeOptionsDate?: SelectItem[];
  matchModeOptionsNumber?: SelectItem[];
  loading = false;
  currentPageNumber = 1
  totalNumberOfPages = 0
  totalNumberOfRecords = 0
  rows = 10
  title: string = "";
  matterDialog: boolean = false;
  viewOnly: boolean = false;
  disableEdit: boolean = false;
  viewMatter: boolean = false;
  viewMatterFilterName: string = "";
  totalRecords: number = 0;
  selectedRow: any = {};
  viewMatterName: any;
  initialLoadDone: boolean = false;

  @ViewChild('dt') matterGrid: any;

  private lastTableLazyLoadEvent: any = null;
  matterSubscription: any;
  projectMatterFilter: any;
  public defaultFilters: { [s: string]: any } = {};

  constructor(private readonly messageService: MessageService,
    private matterService: MatterService, private filterService: helperService,
    private cdr: ChangeDetectorRef, private auth: AuthGuard, private tableStateService: TableStateService) { }

  ngOnInit(): void {

    console.log("Recieved matterOrgFilter in matters component:", this.matterOrgFilter);

    if (!this.auth.roles.includes("ADMIN") && this.auth.roles.includes("TK") && this.auth.roles.includes("LPC")) {
      this.disableEdit = true;
    }
    this.cols = [
      { field: 'name', header: 'Matter Name' },
      { field: 'orgName', header: 'Organisation Name' },
      { field: 'orgQbId', header: 'QuickBook Id' },
      { field: 'number', header: 'Matter Number' },
      { field: 'statusCode', header: 'Status' },
      { field: 'createDate', header: 'Date Created', data: true, format: `MM/dd/yyyy` },
    ];

    this.statuses = matter.statuses;

    // this.matchModeOptionsString = [
    //   { label: 'Equals', value: FilterMatchMode.EQUALS },
    //   { label: 'Contains', value: FilterMatchMode.CONTAINS },
    // ];

    this.matchModeOptionsDate = matchModeOptionsDateList;

    // this.matchModeOptionsNumber = [
    //   { label: 'Equal', value: FilterMatchMode.EQUALS },
    //   { label: 'Greater than', value: FilterMatchMode.GREATER_THAN },
    //   { label: 'Less than', value: FilterMatchMode.LESS_THAN },
    //   { label: 'Between', value: FilterMatchMode.BETWEEN },
    // ];

    const saved = this.tableStateService.getState('matter_grid', this.auth.jwtData.email);

    if (saved && !this.initialLoadDone) {
      this.restoreState(saved);
    }

    const target = history.state?.openMatter;
    if (target?.id) {
      history.replaceState({ ...history.state, openMatter: null }, '');
      this.matterService.getMatterById(target.id).subscribe((res: any) => {
        if (res?.data) this.clicked(res.data);
      });
    }
  }

  loadMatterData(event: LazyLoadEvent) {
    this.saveState('matter_grid', this.auth.jwtData.email, event, {});
    this.lastTableLazyLoadEvent = event;
    event.first = event.first ? event.first : 1;
    event.rows = event.rows ? event.rows : 10;
    let payload = this.filterService.generateEventPayload(event)
    this.loading = true;
    if (this.matterOrgFilter) {
      payload.filters.push({
        "field": "orgId",
        "operator": "equals",
        "value": this.matterOrgFilter
      })
    }
    if (this.matterSubscription)
      this.matterSubscription.unsubscribe();
    this.matterSubscription = this.matterService.getAllMatters(Math.floor(event.first / event.rows + 1), event.rows, payload).subscribe((res: any) => {
      this.matterData = res.data;
      this.currentPageNumber = res.customValues.currentPageNumber;
      this.totalNumberOfPages = res.customValues.totalNumberOfPages;
      this.totalRecords = res.customValues.totalNumberOfRecords;
      this.loading = false;
    })
  }

  editMatter(view: Boolean, matterObj: any) {
    this.title = "Edit Matter"
    this.matterDialog = true;
    matterObj.isBillable = matterObj.isBillable == 'Y' ? true : false;
    this.selectedRow = matterObj;
    if (view) {
      this.viewOnly = true;
    }
  }

  closeDialog() {
    this.matterDialog = false;
    this.viewOnly = false;
    this.viewMatter = false;
    this.cdr.detectChanges();
    this.loadMatterData(this.lastTableLazyLoadEvent);
  }

  backToMatterGrid() {
    this.viewMatter = false;
    this.loadMatterData(this.lastTableLazyLoadEvent);
  }

  clicked(data: any) {
    this.selectedRow = data;
    console.log("selectedrow", this.selectedRow)
    this.projectMatterFilter = this.selectedRow.id;
    this.viewMatter = true;
    this.viewMatterName = this.selectedRow.name;
  }


  restoreState(saved: any) {
    const event = saved.event;

    setTimeout(() => {
      if (this.matterGrid) {

        const filtersAreValid = event.filters && Object.keys(event.filters).length > 0;

        // 2. Assign filters: Use saved filters if valid, otherwise use the captured default filters.
        if (filtersAreValid) {
          this.matterGrid.filters = event.filters;
        } else if (Object.keys(this.defaultFilters).length > 0) {
          // 🔥 Use the default structure as a fallback to prevent empty filter popups
          this.matterGrid.filters = this.defaultFilters;
        }

        // Restore sorting
        this.matterGrid.sortField = event.sortField ?? '';
        this.matterGrid.sortOrder = event.sortOrder ?? 0;

        // 🔥 force PrimeNG to show sorting icons
        this.matterGrid.sortSingle();

        // Restore paginator
        this.matterGrid.first = event.first ?? 0;
        this.matterGrid.rows = event.rows ?? 10;

        // Trigger reload
        this.matterGrid.onLazyLoad.emit(event);
      }
    }, 50);

    this.initialLoadDone = true;
  }

  saveState(screen: string, userId: string, event: LazyLoadEvent, customFilters: any) {
    const state: SavedTableState = {
      event: {
        first: event.first,
        rows: event.rows,
        sortField: event.sortField,
        sortOrder: event.sortOrder,
        filters: event.filters
      },
      customFilters: { ...customFilters }
    };

    this.tableStateService.saveState(screen, userId, state);
  }

  
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.matterGrid && this.matterGrid.filters) {
        this.defaultFilters = JSON.parse(JSON.stringify(this.matterGrid.filters));
      }
    });
  }

}
